"use client";

import { useEffect } from "react";

import { setBuilderPageSettings } from "@/store/features/globalSlice";
import { useAppDispatch } from "@/store/hooks";

/**
 * Rendered by builder-driven pages (home, [slug], category, brand) to push
 * the page's settings (background color/style) up to the layout shell.
 */
export default function SetBuilderPageSettings({
  settings,
}: {
  settings: any;
}) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setBuilderPageSettings(settings || null));
    return () => {
      dispatch(setBuilderPageSettings(null));
    };
  }, [dispatch, settings]);

  return null;
}
